export function dataInRequest(params = {}) {
  return {
    type: '@vazaoPosto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@vazaoPosto/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@vazaoPosto/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@vazaoPosto/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@vazaoPosto/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@vazaoPosto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@vazaoPosto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@vazaoPosto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@vazaoPosto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@vazaoPosto/RECORD_FILTERING',
    payload: { params },
  };
}

export function updateNozzle(value, position) {
  return {
    type: '@vazaoPosto/UPDATE_NOZZLE',
    payload: { value, position },
  };
}
